import {Record, Map} from 'immutable';

import {makeReducer, match} from 'web-app/util/redux';
import {PARENT_ROLE_ID} from 'web-app/react/entities/common/role';

import * as Actions from './actions';
import {relationIdsFromChildren, relationIdsWithChildIds} from './helpers';

export interface InviteParentsStateProps {
    readonly loading: boolean;
    readonly creating: boolean;
    readonly relationIdChildIdMap: Map<string, string>;
    readonly relationIdsToInvite: Map<string, boolean>;
    readonly relationRoles: Map<string, string>;
    readonly relationIdsLoading: Map<string, boolean>;
}

export class InviteParentsState extends Record<InviteParentsStateProps>({
    loading: false,
    creating: false,
    relationIdChildIdMap: Map(),
    relationIdsToInvite: Map(),
    relationRoles: Map(),
    relationIdsLoading: Map(),
}) {}

export default makeReducer<InviteParentsState>(
    [
        match(
            Actions.fetchChildren,
            () =>
                new InviteParentsState({
                    loading: true,
                }),
        ),
        match(Actions.fetchChildrenSuccess, (state, {payload}) =>
            state.merge({
                loading: false,
                relationIdChildIdMap: Map(relationIdsWithChildIds(payload.children)),
                relationIdsToInvite: Map(relationIdsFromChildren(payload.children).map(rel => [rel, true])),
                relationRoles: Map(relationIdsFromChildren(payload.children).map(rel => [rel, PARENT_ROLE_ID])),
            }),
        ),
        match(Actions.fetchChildrenFailed, state =>
            state.merge({
                loading: false,
            }),
        ),
        match(Actions.setAll, (state, {payload}) =>
            state.merge({
                relationIdsToInvite: state.relationIdsToInvite.map(() => payload.setTo),
            }),
        ),
        match(Actions.setRole, (state, {payload}) =>
            state.merge({
                relationRoles: state.relationRoles.set(payload.relationId, payload.roleId),
            }),
        ),
        match(Actions.toggleLoginId, (state, {payload}) =>
            state.merge({
                relationIdsToInvite: state.relationIdsToInvite.set(
                    payload.relationId,
                    !state.relationIdsToInvite.get(payload.relationId),
                ),
            }),
        ),
        match(Actions.assignRole, (state, {payload}) =>
            state.merge({
                relationIdsLoading: state.relationIdsLoading.set(payload.relationId, true),
            }),
        ),
        match(Actions.assignRoleSuccess, (state, {payload}) =>
            state.merge({
                relationIdsLoading: state.relationIdsLoading.set(payload.relationId, false),
            }),
        ),
        match(Actions.assignRoleFailed, (state, {payload}) =>
            state.merge({
                relationIdsLoading: state.relationIdsLoading.set(payload.relationId, false),
            }),
        ),
    ],
    new InviteParentsState(),
);
